import { render, staticRenderFns } from "./StatDevice.vue?vue&type=template&id=7247db04&scoped=true&"
import script from "./StatDevice.vue?vue&type=script&lang=js&"
export * from "./StatDevice.vue?vue&type=script&lang=js&"
import style0 from "./StatDevice.vue?vue&type=style&index=0&id=7247db04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247db04",
  null
  
)

export default component.exports